<mlp-ng-input [(ngModel)]="reverseAddress"
    (input)="searchTerm$.next(reverseAddress)"
    [inputId]="inputSetup.id"
    icon="compass-direction"
    [placeholder]="inputSetup.placeholder"
    [errors]="errors"
    (keydown.enter)="onEnter();false"
    (keydown.escape)="closeDropDown();false"
    (keydown.ArrowDown)="arrowDown();false"
    (keydown.ArrowUp)="arrowUp();false"></mlp-ng-input>

<ul class="autocomplete" *ngIf="predictions.length > 0">

    <li class="autocomplete__item" (click)="setFromSuggestion(item);closeDropDown()" *ngFor="let item of predictions; let i = index" [class.selected]="selectedIndex == i+1">
        <mlp-ng-icon class="autocomplete__icon pr-2" name="style-two-pin-marker" size="small"></mlp-ng-icon>
        {{ item.structured_formatting.main_text }}
    </li>

    <li class="autocomplete__item autocomplete__item--close" (click)="closeDropDown()">
        Close
    </li>

</ul>
